import { combineSlices } from "@reduxjs/toolkit";
import { animalLoaderSlice } from "./loader-slice";
import { activeSectionSlice } from "./activeSectionSlice";
import { activeAnimalSlice } from "./activeAnimalSlice";

export const stateSlice = combineSlices({
  animalLoader: animalLoaderSlice.reducer,
  section: activeSectionSlice.reducer,
  activeAnimal: activeAnimalSlice.reducer
})